import { PageHeader } from "@/shared/ui/PageHeader";

export function EvidencePage() {
  return (
    <section>
      <PageHeader
        eyebrow="Evidence"
        title="Evidence feed"
        subtitle="Feature slice placeholder — migrate frontend/app/evidence.html here."
      />
    </section>
  );
}